import React from 'react';

const Contacts = () => {
  return (
    <div className="contacts">
      <h1>Contacts</h1>
      <div className="contacts-content">
        {/* Contacts content will go here */}
      </div>
    </div>
  );
};

export default Contacts; 